import { render } from "./InputComponent.vue?vue&type=template&id=31e5cbef"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import "./InputComponent.vue?vue&type=style&index=0&id=31e5cbef&lang=scss"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__